// Paging for the wallet statement. The endpoint returns the newest N rows and
// takes `before=<id>` for the rows older than that; the page keeps appending
// until a short page says there is nothing older (2026-09-04: the list used to
// stop at 100 rows with no way down, and a "load more" that only re-sliced
// those same 100).

export type StatementLike = { id: number | string };

export const STATEMENT_PAGE_SIZE = 100;

/**
 * The cursor for the next page, or null when the last page came back short —
 * a full page means there may be more; anything less means we have it all.
 */
export function nextStatementCursor<T extends StatementLike>(pages: T[][], pageSize = STATEMENT_PAGE_SIZE): string | null {
  const last = pages[pages.length - 1];
  if (!last || last.length < pageSize) return null;
  const tail = last[last.length - 1];
  return tail ? String(tail.id) : null;
}

/** Pages flattened newest-first, deduplicated by id (a refetch can overlap). */
export function mergeStatementPages<T extends StatementLike>(pages: T[][]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const page of pages) {
    for (const row of page) {
      const key = String(row.id);
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(row);
    }
  }
  return out;
}
